import React, { useState, useEffect } from 'react';
import { Layout, Menu, theme } from 'antd';
import { useLocation } from 'react-router-dom';
import { getHostName } from '../../utils/config';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  DashboardOutlined,
  LogoutOutlined,
  LinkOutlined,
  SwapOutlined,
  WalletOutlined,
  MonitorOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { useNavigate, Routes, Route } from 'react-router-dom';
import Chains from '../Chains';
import Transfers from '../Transfers';
import Incomes from '../Incomes';
import MonitorPage from '../Monitor';
import Profile from '../Profile';
import AssetBalance from '../AssetBalance';
import AdminLoginLogs from '../AdminLoginLogs';
import Explorer from '../Explorer';
import BlockDetail from '../Explorer/BlockDetail';
import TransactionDetail from '../Explorer/TransactionDetail';
import AddressDetail from '../Explorer/AddressDetail';
import AssetDetail from '../Explorer/AssetDetail';
import './style.css';

const { Header, Sider, Content } = Layout;

const Dashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCollapsed(true);
      }
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 根据路径获取当前选中的菜单项
  const getSelectedKey = () => {
    const path = location.pathname;
    if (path === '/dashboard') return 'dashboard';
    if (path.includes('/dashboard/chains')) return 'chains';
    if (path.includes('/dashboard/transfers')) return 'transfers';
    if (path.includes('/dashboard/incomes')) return 'incomes';
    if (path.includes('/dashboard/monitor')) return 'monitor';
    if (path.includes('/dashboard/asset-balance')) return 'asset-balance';
    if (path.includes('/dashboard/profile')) return 'profile';
    if (path.includes('/dashboard/admin-login-logs')) return 'admin-login-logs';
    if (path.includes('/dashboard/explorer')) return 'explorer';
    return 'dashboard';
  };

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <Layout className="dashboard-layout">
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo">{getHostName()} Rialto</div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[getSelectedKey()]}
          defaultSelectedKeys={['1']}
          items={[
            {
              key: 'dashboard',
              icon: <DashboardOutlined />,
              label: '仪表盘',
              onClick: () => navigate('/dashboard'),
            },
            {
              key: 'explorer',
              icon: <SearchOutlined />,
              label: '区块浏览器',
              onClick: () => navigate('/dashboard/explorer'),
            },
            {
              key: 'chains',
              icon: <LinkOutlined />,
              label: '链',
              onClick: () => navigate('/dashboard/chains'),
            },
            {
              key: 'transfers',
              icon: <SwapOutlined />,
              label: '转账记录',
              onClick: () => navigate('/dashboard/transfers'),
            },
            {
              key: 'incomes',
              icon: <WalletOutlined />,
              label: '收入记录',
              onClick: () => navigate('/dashboard/incomes'),
            },
            {
              key: 'monitor',
              icon: <MonitorOutlined />,
              label: '充提监控',
              onClick: () => navigate('/dashboard/monitor'),
            },
            {
              key: 'asset-balance',
              icon: <WalletOutlined />,
              label: '资产余额',
              onClick: () => navigate('/dashboard/asset-balance'),
            },
            {
              key: 'profile',
              icon: <UserOutlined />,
              label: '个人信息',
              onClick: () => navigate('/dashboard/profile'),
            },
            {
              key: 'admin-login-logs',
              icon: <MonitorOutlined />,
              label: '登录日志',
              onClick: () => navigate('/dashboard/admin-login-logs'),
            },
          ]}
        />
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: colorBgContainer }}>
          <div className="header-content">
            {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'trigger',
              onClick: () => setCollapsed(!collapsed),
            })}
            <Menu
              mode="horizontal"
              className="header-menu"
              items={[
                {
                  key: 'logout',
                  icon: <LogoutOutlined />,
                  label: '退出登录',
                  onClick: handleLogout,
                },
              ]}
            />
          </div>
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            overflow: 'auto'
          }}
        >
          <Routes>
            <Route path="/" element={<div>欢迎来到Rialto管理系统</div>} />
            <Route path="/explorer" element={<Explorer />} />
            <Route path="/explorer/:chainId" element={<Explorer />} />
            <Route path="/explorer/block/:id" element={<BlockDetail />} />
            <Route path="/explorer/transaction/:txid" element={<TransactionDetail />} />
            <Route path="/explorer/address/:id" element={<AddressDetail />} />
            <Route path="/explorer/asset/:id" element={<AssetDetail />} />
            <Route path="/chains" element={<Chains />} />
            <Route path="/transfers" element={<Transfers />} />
            <Route path="/incomes" element={<Incomes />} />
            <Route path="/monitor" element={<MonitorPage />} />
            <Route path="/asset-balance" element={<AssetBalance />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin-login-logs" element={<AdminLoginLogs />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
